import { render } from "./RelatorioPontoDiarioPublic.vue?vue&type=template&id=31ce2aba&scoped=true"
import script from "./RelatorioPontoDiarioPublic.vue?vue&type=script&lang=js"
export * from "./RelatorioPontoDiarioPublic.vue?vue&type=script&lang=js"

import "./RelatorioPontoDiarioPublic.vue?vue&type=style&index=0&id=31ce2aba&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ce2aba"]])

export default __exports__